import vue from "vue";

export const fetchAllItems = async (payload) => {
	const res = await vue.axios.post(`/home/list/all`, payload);
	return res.data.data;
};

export const fetchMarketList = async (city) => {
	const res = await vue.axios.get(
		`/catalog/api/catalog/read/catalog/filter?isCategory=y&city=${city}`
	);
	return res.data.response;
};
